// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type { ReactNode } from "react";
import { AccessDenied } from "@/components/shared/access-denied";
import { useAuth } from "@/lib/auth/auth-provider";

interface RequirePermissionProps {
  permission: string;
  children: ReactNode;
}

export function RequirePermission({ permission, children }: RequirePermissionProps) {
  const { hasPermission } = useAuth();
  if (!hasPermission(permission)) return <AccessDenied permission={permission} />;
  return <>{children}</>;
}
